import { RouteObject } from 'react-router-dom';
import { FeatureForEmployers } from './feature-for-employers';

export const WEB_ROUTES: RouteObject[] = [
   {
      path: '/foremployers',
      Component: FeatureForEmployers,
   },
];
